import axios from 'axios';
import { DamAssets } from './DamAssets';
import { updateCartCounter } from './DamCartCounter';
import { route } from 'ziggy-js';

export class DamCart {
    constructor() {
        this.damAssetUniqueCodes = [];
        this.shareLink = '';
    }

    init() {
        $('#damCartModal').modal('show');

        this.assets();
    }

    async assets() {
        if (document.querySelector('#damCartAssets *')) {
            document.querySelector('#damCartAssets').innerHTML = '';
        }

        const { data } = await axios.get(route('dam.asset-structure'), {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        document.querySelector('#damCartAssets').insertAdjacentHTML('beforeend', data);

        document.querySelectorAll('*[data-role=assetContainer]').forEach(el => {
            this.damAssetUniqueCodes.push(el.dataset.damAssetUniqueCode);
        });

        this.actions();
        this.assetShareLink();
    }

    async assetShareLink() {
        const { data } = await axios.get(route('dam.get-share-link'), {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        this.shareLink = data;
        document.querySelector('#damCartAssetsShareLink').value = this.shareLink;
    }

    async copyAssetShareLink() {
        document.querySelector('#damCartAssetsShareLink').select();

        document.execCommand('copy');
    }

    actions() {
        document.querySelector('*[data-role=copyCartAssetsShareLink]').onclick = e => {
            this.copyAssetShareLink();
        };

        document.querySelectorAll('a[data-role=deleteDamCartAsset]').forEach(el => {
            el.onclick = async e => {
                let anchor = e.target.closest('a[class=cart-asset-delete-icon]');
                await axios.delete(route('dam.delete-cart-asset', { damAsset: anchor.dataset.damAssetId }), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                this.assets();
                updateCartCounter();

                const damAssets = new DamAssets();

                damAssets.assets();
            };
        });

        if (document.querySelector('*[data-role=deleteAllCartAssets]')) {
            document.querySelector('*[data-role=deleteAllCartAssets]').onclick = async e => {
                e.preventDefault();

                await axios.delete(route('dam.delete-all-current-cart-assets'), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                $('#damCartModal').modal('hide');

                updateCartCounter();

                const damAssets = new DamAssets();

                damAssets.assets();
            };
        }

        document.querySelectorAll('*[data-role=downloadAsset]').forEach(el => {
            el.onclick = e => {
                e.preventDefault();

                this.download([el.closest('a').dataset.damAssetUniqueCode]);
            };
        });

        document.querySelector('*[data-role=downloadAllAssets]').onclick = async e => {
            e.preventDefault();

            this.downloadAll(this.damAssetUniqueCodes);
        };
    }

    async download(damAssetUniqueCode) {
        const { data } = await axios.get(route('dam.download-single-zip', { zipFileName: damAssetUniqueCode }), {
            params: {
                dam_asset_unique_codes: damAssetUniqueCode,
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        window.location = data;
    }

    async downloadAll(damAssetUniqueCodes) {
        $('#damCartModal').modal('hide');
        $('#dam-cart-loader-modal').modal('show');
        axios.post(route('dam.generate-zip'), {
                dam_asset_unique_codes: damAssetUniqueCodes
            },
            {
                headers: {
                    'Accept': 'application/json'
            }
        }).then(response => {
            let files = response.data;
            let index = 0;
            while(index < files.length) {
                let download_iframe = $('<iframe />')
                                        .attr('src', '/splittedzips/download/' + files[index])
                                        .hide()
                                        .appendTo('body');
                index++;
            }

            setTimeout(() => {
                $('#dam-cart-loader-modal').modal('hide');
            }, 1000);
        });
    }
}
